import React, { useState } from "react"

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]))
  } catch (e) {
    return null
  }
}

const AuthContext = React.createContext({
  token: null,
  checkisLoggedIn: () => {},
  login: (token) => {},
  logout: () => {},
  isLoggedIn: false,
})

export const AuthContextProvider = (props) => {
  const initialToken = localStorage.getItem("token")
  const [token, setToken] = useState(initialToken)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const loginHandler = (token) => {
    setToken(token)
    localStorage.setItem("token", token)
    userIsLoggedIn()
  }

  const userIsLoggedIn = () => {
    if (!localStorage.getItem("token")) {
      setIsLoggedIn(false)
      return false
    }

    const decodedJwt = parseJwt(localStorage.getItem("token"))

    if (decodedJwt.exp * 1000 < Date.now()) {
      logoutHandler()
      setIsLoggedIn(false)
      return false
    }

    setIsLoggedIn(true)
    return true
  }

  const logoutHandler = () => {
    setToken(null)
    localStorage.removeItem("token")
    localStorage.removeItem("worksites")
    localStorage.clear()
    userIsLoggedIn()
  }

  const contextValue = {
    token: token,
    checkisLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
    isLoggedIn: isLoggedIn,
  }

  return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>
}

export default AuthContext
